module.exports = __webpack_public_path__ + "media/icons/skinny-arrow-4d1927f3.png";